import React from "react";
import ProfileTitle from "../../components/ProfileTitle";
import Styles from "../platform-pages/admin/sys-site/site.module.css";
import {Button, Form, Input, message} from "antd";
import {useRequest} from "ahooks";
import * as api from "../../apis/apiConfig";


export default function JdConfig() {

    const [form] = Form.useForm()

    useRequest(api.getApiConfiguration, {
        defaultParams: ['jd'],
        onSuccess: response => {
            form.setFieldsValue(response.data.data)
        }
    })

    const {run, loading} = useRequest(api.modifyApiConfiguration, {
        manual: true,
        onSuccess: () => {
            message.success("保存成功")
        }
    })

    return (
        <div>
            <ProfileTitle>京东快递客户编码配置</ProfileTitle>
            <div className={Styles.container}>
                <Form form={form} layout={"vertical"} style={{width: 300}} onFinish={values => run('jd', values)}>
                    <Form.Item label={'客户编码'} name={'customCode'}
                               rules={[{required: true, message: '请输入京东快递客户编码'}]}>
                        <Input/>
                    </Form.Item>
                    <div style={{textAlign: "center"}}>
                        <Button type={"primary"} loading={loading} htmlType={'submit'}>保存</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}
